export default __webpack_public_path__ + "images/Ignite Donuts Logo.png";